import { firebaseConfig } from "./firebaseConfig";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

let analytics: any;

export const initFirebase = () => {
  if (process.env.REACT_APP_ENABLE_ANALYTICS === "True") {
    if (firebaseConfig && firebaseConfig.apiKey) {
      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      analytics = getAnalytics(app);
    }
  }
};

export const logFirebaseEvent = (eventName: string, params?: object): void => {
  if (process.env.REACT_APP_ENABLE_ANALYTICS === "True") {
    logEvent(analytics, eventName, params);
  }
};
